import { render, staticRenderFns } from "./stepResult.vue?vue&type=template&id=2c6ec2d5&scoped=true&"
import script from "./stepResult.vue?vue&type=script&lang=js&"
export * from "./stepResult.vue?vue&type=script&lang=js&"
import style0 from "./stepResult.vue?vue&type=style&index=0&id=2c6ec2d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6ec2d5",
  null
  
)

export default component.exports